// Firestore reads return Timestamps; older records may contain strings or Dates.
export const formatPrintDate = (value) => {
  if (value === null || value === undefined || value === "") return "";

  try {
    const date =
      typeof value.toDate === "function"
        ? value.toDate()
        : typeof value.seconds === "number"
          ? new Date(value.seconds * 1000)
          : new Date(value);

    return Number.isNaN(date.getTime())
      ? ""
      : date.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "long",
          year: "numeric",
        });
  } catch {
    return "";
  }
};
